(function($) {

	$.fn.floatingLabels = function(options) {
		var visibleStateClass = 'is-visible',
			activeStateClass  = 'is-active',
			$inputPairInputs = $('.form__input-pair input, .form__input-pair textarea');

		var init = function() {
			$inputPairInputs.bind("checkval",function(){
				var label = $(this).prev("label");
				if(this.value !== ""){
					label.addClass(visibleStateClass);
				} else {
					label.removeClass(visibleStateClass);
				}
			}).on("keyup",function(){
				$(this).trigger("checkval");
			}).on("focus",function(){
				$(this).prev("label").addClass(activeStateClass);
			}).on("blur",function(){
				$(this).prev("label").removeClass(activeStateClass);
			}).trigger("checkval");
		};

		init();
		return this;
	};

}($));
